export default __webpack_public_path__ + "static/logo-6-18d56cdd1f16e9eda841fefe6b78a82c.png";